exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apexcharts-tooltip{background:rgba(0,0,0,.7)!important;color:#fff!important;border-radius:3px!important;padding:10px!important;font-size:12px!important;width:auto!important;min-width:260px!important;max-width:360px!important;height:auto!important;overflow-y:scroll!important;font-family:Helvetica Neue,Helvetica,Arial,sans-serif!important;white-space:normal!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b55310e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/climan/ResultadosDetallado.vue
// module id = 1031
// module chunks = 2